export default __webpack_public_path__ + "static/media/samy.7d0a0629.png";